import {useEffect, useState} from 'react';
import {mmkvStorage} from '../Utils/mmkvStorage';

const useLocalState = (key, defaultValue) => {
  const [localState, setLocalState] = useState(defaultValue);

  const getSavedValue = async () => {
    const savedValue = await mmkvStorage.getString(key);
    if (savedValue) {
      setLocalState(savedValue);
      // return Alert.alert(savedValue);
    }
  };

  useEffect(() => {
    getSavedValue();
  }, []);

  useEffect(() => {
    console.log('updating local state', {key, localState});
    if (localState) {
      mmkvStorage.set(key, localState + '');
    }
  }, [localState]);

  return [localState, setLocalState];
};

export default useLocalState;
